export const intervalos = {
    duas_horas: '02:00',
    seis_horas: '06:00',
};
